export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {

};

export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    'background'		: imgsPath + "reels/reels_background_{q}.png",
    'bonus_bg'			: imgsPath + "reels/reels_background_mystery_mini_{q}.png",
    'reels_cover' 		: imgsPath + "reels/reels_cover_{q}.png",
    'logo_reels' 		: imgsPath + "reels/logo_reels_{q}.png",

    'logo_reels_shine' 	: imgsPath + "reels/logo_reels_shine_{q}.png",

    'settings_background_1'	: imgsPath + 'infos/wintable_1_{q}.png',
    'settings_background_2'	: imgsPath + 'infos/wintable_2_{q}.png',
    'settings_background_3'	: imgsPath + 'infos/wintable_3_{q}.png',

    'bonus_background'	 		: imgsPath + 'bonus/bonus_background_{q}.png',
    'mystery_arrow_center' 		: imgsPath + 'bonus/Mystery_arrow-center_{q}.png',
    'mystery_arrow_left' 		: imgsPath + 'bonus/Mystery_arrow-left_{q}.png',
    'mystery_arrow_right' 		: imgsPath + 'bonus/Mystery_arrow-right_{q}.png',
    'mystery_hand' 				: imgsPath + 'bonus/Mystery_hand_{q}.png',
    'mystery_wheel' 			: imgsPath + 'bonus/Mystery_Wheel_{q}.png',
    'mystery_wheel_center' 		: imgsPath + 'bonus/Mystery_Wheel_Center_{q}.png',

    'bw_bg' 		: imgsPath + 'bigwin/big-win_background_{q}.png',
    'bw_shine' 		: imgsPath + 'bigwin/big-win_shine_{q}.png',
    'bw_stroke' 	: imgsPath + 'bigwin/big-win_stroke_{q}.png',
    'bw_table' 		: imgsPath + 'bigwin/table_big-win_{q}.png',
    'bw_big' 		: imgsPath + 'bigwin/text_big-win_{q}.png',
    'bw_mega' 		: imgsPath + 'bigwin/text_mega-win_{q}.png',
    'bw_super' 		: imgsPath + 'bigwin/text_super-mega-win_{q}.png',

    'wing_left'		: imgsPath + 'bonus/wing_left_sprite_{q}.png',
    'wing_right'	: imgsPath + 'bonus/wing_right_sprite_{q}.png',

    'mystery_symbol'    : imgsPath + "bonus/Mystery_symbol_{q}.png",
    'Mystery_Win'       : imgsPath + "bonus/Mystery_Win_{q}.png",
    'table_bonus_win'   : imgsPath + "bonus/table_bonus-win_{q}.png"
};

export const to_load_audio = {

    'win'			: audioPath + "bwin_BigWin.ogg",

    'reels'			: audioPath + "reel_Spin.ogg",

    'pre_reels'		: audioPath + "reel_Start.ogg",

    'reel_stop_1'	: audioPath + "reel_Stop_1.ogg",
    'reel_stop_2'	: audioPath + "reel_Stop_2.ogg",
    'reel_stop_3'	: audioPath + "reel_Stop_3.ogg",

    'win7_1'		: audioPath + "win_7_1.ogg",
    'win7_2'		: audioPath + "win_7_2.ogg",
    'win7_3'		: audioPath + "win_7_3.ogg",
    'winBAR_1'		: audioPath + "win_Bar_1.ogg",
    'winBAR_2'		: audioPath + "win_Bar_2.ogg",
    'winBAR_3'		: audioPath + "win_Bar_3.ogg",
    'winBell_1'		: audioPath + "win_Bell_1.ogg",
    'winBell_2'		: audioPath + "win_Bell_2.ogg",
    'winBell_3'		: audioPath + "win_Bell_3.ogg",
    'winDolar_1'	: audioPath + "win_Dollar_1.ogg",
    'winDolar_2'	: audioPath + "win_Dollar_2.ogg",
    'winDolar_3'	: audioPath + "win_Dollar_3.ogg",
    'winGrapes_1'	: audioPath + "win_Grape_1.ogg",
    'winGrapes_2'	: audioPath + "win_Grape_2.ogg",
    'winGrapes_3'	: audioPath + "win_Grape_3.ogg",
    'winCherry_1'	: audioPath + "win_Cherry_1.ogg",
    'winCherry_2'	: audioPath + "win_Cherry_2.ogg",
    'winCherry_3'	: audioPath + "win_Cherry_3.ogg",
    'winMeloun_1'	: audioPath + "win_Melon_1.ogg",
    'winMeloun_2'	: audioPath + "win_Melon_2.ogg",
    'winMeloun_3'	: audioPath + "win_Melon_3.ogg",
    'winOrange_1'	: audioPath + "win_Orange_1.ogg",
    'winOrange_2'	: audioPath + "win_Orange_2.ogg",
    'winOrange_3'	: audioPath + "win_Orange_3.ogg",
    'winPlum_1'		: audioPath + "win_Plum_1.ogg",
    'winPlum_2'		: audioPath + "win_Plum_2.ogg",
    'winPlum_3'		: audioPath + "win_Plum_3.ogg",

    'background'				: audioPath + "bg_Music.ogg",


    'background_mystery'		: audioPath + "bg_Mystery.ogg",
    'background_pre_mystery'	: audioPath + "bg_Mystery_Start.ogg",
    'bonus_Mystery_Start'				: audioPath + "bonus_Mystery_Start.ogg",

    'symbol_Wild'				: audioPath + "symbol_Wild.ogg",
    'symbol_Mystery'			: audioPath + "symbol_Mystery.ogg",

    'reel_Search'				: audioPath + "reel_Search.ogg",

    'bonus_Wheel'			: audioPath + "bonus_Wheel.ogg",
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",
};

export const to_load_json = {
    'infotext' 					: "assets/info/info_{l}.json",
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },
    'big-win' :	{
        img:	imgsPath + 'fonts/font_bigwin.png',
        xml:	imgsPath + 'fonts/font_bigwin.xml',
    },
    'wintable' :	{
        img:	imgsPath + 'fonts/font_wintable.png',
        xml:	imgsPath + 'fonts/font_wintable.xml',
    }
};

import {
    madnes_audio_allow_multiple,
    madnes_audio_levels,
    madnes_set_audio_volume
} from "../../framework/src/engine/madnes/madnes_audio";
import {to_load_audio_madnes} from "../../framework/src/engine/madnes/madnes_variables";

export function set_sounds(server_config)
{
    if(typeof server_config.volume.bigWin != "undefined")
    {
        madnes_set_audio_volume('win', server_config.volume.bigWin);
    }
    if(typeof server_config.volume.buttonEffect != "undefined")
    {
        madnes_set_audio_volume('button_click', server_config.volume.buttonEffect);
    }
    if(typeof server_config.volume.spin != "undefined")
    {
        madnes_set_audio_volume('reels', server_config.volume.spin);
    }
    if(typeof server_config.volume.startReel != "undefined")
    {
        madnes_set_audio_volume('pre_reels', server_config.volume.startReel);
    }
    if(typeof server_config.volume.stopReel != "undefined")
    {
        madnes_set_audio_volume('reel_stop_1', server_config.volume.stopReel);
        madnes_set_audio_volume('reel_stop_2', server_config.volume.stopReel);
        madnes_set_audio_volume('reel_stop_3', server_config.volume.stopReel);
    }
    if(typeof server_config.volume.winAnim != "undefined")
    {
        madnes_set_audio_volume('win7_1', server_config.volume.winAnim);
        madnes_set_audio_volume('win7_2', server_config.volume.winAnim);
        madnes_set_audio_volume('win7_3', server_config.volume.winAnim);
        madnes_set_audio_volume('winBAR_1', server_config.volume.winAnim);
        madnes_set_audio_volume('winBAR_2', server_config.volume.winAnim);
        madnes_set_audio_volume('winBAR_3', server_config.volume.winAnim);
        madnes_set_audio_volume('winBell_1', server_config.volume.winAnim);
        madnes_set_audio_volume('winBell_2', server_config.volume.winAnim);
        madnes_set_audio_volume('winBell_3', server_config.volume.winAnim);
        madnes_set_audio_volume('winDolar_1', server_config.volume.winAnim);
        madnes_set_audio_volume('winDolar_2', server_config.volume.winAnim);
        madnes_set_audio_volume('winDolar_3', server_config.volume.winAnim);
        madnes_set_audio_volume('winGrapes_1', server_config.volume.winAnim);
        madnes_set_audio_volume('winGrapes_2', server_config.volume.winAnim);
        madnes_set_audio_volume('winGrapes_3', server_config.volume.winAnim);
        madnes_set_audio_volume('winCherry_1', server_config.volume.winAnim);
        madnes_set_audio_volume('winCherry_2', server_config.volume.winAnim);
        madnes_set_audio_volume('winCherry_3', server_config.volume.winAnim);
        madnes_set_audio_volume('winMeloun_1', server_config.volume.winAnim);
        madnes_set_audio_volume('winMeloun_2', server_config.volume.winAnim);
        madnes_set_audio_volume('winMeloun_3', server_config.volume.winAnim);
        madnes_set_audio_volume('winOrange_1', server_config.volume.winAnim);
        madnes_set_audio_volume('winOrange_2', server_config.volume.winAnim);
        madnes_set_audio_volume('winOrange_3', server_config.volume.winAnim);
        madnes_set_audio_volume('winPlum_1', server_config.volume.winAnim);
        madnes_set_audio_volume('winPlum_2', server_config.volume.winAnim);
        madnes_set_audio_volume('winPlum_3', server_config.volume.winAnim);
    }
    if(typeof server_config.volume.winCounter != "undefined")
    {
        madnes_set_audio_volume('remittance_A', server_config.volume.winCounter);
        madnes_set_audio_volume('remittance_B', server_config.volume.winCounter);
    }
    if(typeof server_config.background.background != "undefined")
    {
        madnes_set_audio_volume('background', server_config.background.background);
    }
    if(typeof server_config.background.bonusGameBackground != "undefined")
    {
        madnes_set_audio_volume('background_mystery', server_config.background.bonusGameBackground);
        madnes_set_audio_volume('background_pre_mystery', server_config.background.bonusGameBackground);
        madnes_set_audio_volume('bonus_Mystery_Start', server_config.background.bonusGameBackground);
    }
    if(typeof server_config.miscSounds.miscSounds1 != "undefined")
    {
        madnes_set_audio_volume('coins_loop', server_config.miscSounds.miscSounds1);
    }
    if(typeof server_config.miscSounds.miscSounds2 != "undefined")
    {
        madnes_set_audio_volume('symbol_Mystery', server_config.miscSounds.miscSounds2);
        madnes_set_audio_volume('symbol_Wild', server_config.miscSounds.miscSounds2);
    }
    if(typeof server_config.miscSounds.miscSounds3 != "undefined")
    {
        madnes_set_audio_volume('reel_Search', server_config.miscSounds.miscSounds3);
    }
    if(typeof server_config.miscSounds.miscSounds4 != "undefined")
    {
        madnes_set_audio_volume('bonus_Wheel', server_config.miscSounds.miscSounds4);
        madnes_audio_allow_multiple('bonus_Wheel');
    }
    for(var i in to_load_audio_madnes)
    {
        if(typeof madnes_audio_levels[i] == "undefined")
        {
            console.log("Not set " + i);
        }
    }
}

